import { useLayoutEffect } from 'react'
import { useCoachLauncherPlacement } from './CoachLauncherPlacement'

export default function CoachPresentationPending() {
  const registerPending = useCoachLauncherPlacement()?.registerPending
  // A lazy page must finish mounting its dock before the launcher can accept a gesture.
  useLayoutEffect(() => registerPending?.(), [registerPending])
  return null
}
